export default {
  apiDomain: 'api.enrichmentplatform.cloud',
  homeUrl: 'leadsscraper.io',
  company: 'Leadsscraper',
  id: 'enrichmentplatform',
  contactUsUrl: 'https://leadsscraper.io/contact-us/',
  servicesUrl: 'https://leadsscraper.io/services/',
  pricingUrl: 'https://leadsscraper.io/pricing/',
  faqUrl: 'https://leadsscraper.io/faq/',
  tutorialsUrl: 'https://leadsscraper.io/category/scraping/tutorials/',
  videosUrl: '',
  communityUrl: null,
  scheduleCallUrl: null,
  termsOfServiceUrl: 'https://leadsscraper.io/terms-of-service/',
  googleMapsCategoriesUrl: 'https://leadsscraper.io/google-maps-business-categories/',  // TODO make optional
  stripeApiKeys: {
    main: 'pk_live_51RbTMpKdgtaHtIYqH5sRCTiTmttZrflMsjsw0MxM9cf5RuNMlUtb5WLScCjp9NlG1X5jjlxoqyRysrOphGn5t4Yg00QFfeaSl1',
  },
  payPalClientId: 'ARueVrA72AqaNxfGjyEBsW6HlRGJXihQ_DKUPRoxpjYu4zsZ3b-2VgznwRTnlf_6gmOZVIrhjSNtNcR0',
  availablePaymentProviders: {
    paypal: true,
    bank: true,
    crypto: true,
  },
  gaToken: '',
  googleClientId: '276524211034-o0k8j8bq2mi9iori5d7epokamkojvcm8.apps.googleusercontent.com',
  linkedinClientId: '',
  hubspotClientId: null,
  pipedriveClientId: null,
  zohoClientId: null,
  includedServices: [],
  learnMoreLinks: {},
  tutorialsLinks: {},
  otherLinks: {},
  integrationsLinks: {}
};

